export default function SearchIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none">
        <circle cx="7.5" cy="7.5" r="6.75" stroke="#1E3665" strokeWidth="1.5"/>
        <line x1="12.9971" y1="11.9365" x2="17.5305" y2="16.4698" stroke="#1E3665" strokeWidth="1.5"/>
    </svg>
  );
}
